type BusinessUserFeatures = {
  PROFILE: string;
  UNIQUE_SELLING_POINTS: string;
  SELLER_PROFILE_URL: string;
  PROFILE_COMPANY_PHOTO_AND_LOGO: string;
  NO_COMMERCIAL_CONTENT: string;
  BRAND_DEALER_INDICATION: string;
  WORKSHOP_SERVICES: string;
  PROFILE_BRANDS: string;
  DEALER_ACCESS: string;
};

const BUSINESS_USER_FEATURES: BusinessUserFeatures = {
  PROFILE: 'PROFILE',
  UNIQUE_SELLING_POINTS: 'UNIQUE_SELLING_POINTS',
  SELLER_PROFILE_URL: 'SELLER_PROFILE_URL',
  PROFILE_COMPANY_PHOTO_AND_LOGO: 'PROFILE_COMPANY_PHOTO_AND_LOGO',
  NO_COMMERCIAL_CONTENT: 'NO_COMMERCIAL_CONTENT',
  BRAND_DEALER_INDICATION: 'BRAND_DEALER_INDICATION',
  WORKSHOP_SERVICES: 'WORKSHOP_SERVICES',
  PROFILE_BRANDS: 'PROFILE_BRANDS',
  DEALER_ACCESS: 'DEALER_ACCESS',
};

export default BUSINESS_USER_FEATURES;
